import { useMutation } from '@tanstack/react-query';
import { PermissionAssignmentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionAssignmentsControllerUpdateAssignmentMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['permissionAssignmentsControllerUpdateAssignment', accessControlScope],
        mutationFn: async (args) => {
            const api = new PermissionAssignmentsApi(accessControlConfig);
            return api.permissionAssignmentsControllerUpdateAssignment(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionAssignmentsControllerUpdateAssignmentMutation.js.map